import {Injectable} from "@angular/core";
import {CustomHttpService} from "./CustomHttp.service";
import {Observable} from "rxjs/Rx";
import {ResponseResult} from "../shared/ResponseResult";
import {API_CONSTANTS} from "../common/constant/ApiConstants";
import {Login} from "../shared/Login";
//import 'rxjs/Rx';

@Injectable()
export class LoginService {
  constructor(private customHttpService:CustomHttpService) {
  }

  // Create new User
  createNewUser(login:Login):Observable<ResponseResult<Login>> {
    return this.customHttpService.post(API_CONSTANTS.CREATE_NEW_USER_URL, JSON.stringify(login));
  }

  // User Login **** Pending
  userLogin(login:Login):Observable<ResponseResult<Login>> {
    /*return this.customHttpService.get(API_CONSTANTS.CREATE_NEW_USER_URL_TEST);*/
    return this.customHttpService.post(API_CONSTANTS.USER_LOGIN, JSON.stringify(login));
  }

  // get authenticate user
  getAuthenticateUser():Observable<ResponseResult<Login>> {
    var url = API_CONSTANTS.GET_AUTHENTICATE_USER;
    return this.customHttpService.post(API_CONSTANTS.GET_AUTHENTICATE_USER, "");
  }

}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts